let token = null;
let revision = 0;
const listeners = new Set();

export const getCachedSessionToken = () => {
  try {
    return sessionStorage.getItem('authToken');
  } catch (error) {
    console.warn('Session cache is unavailable:', error.message);
    return null;
  }
};
export const isTransientSessionError = (error) =>
  error instanceof TypeError || error.status >= 500 || [408, 429].includes(error.status);

export const getSessionToken = () => token;
export const getSessionRevision = () => revision;
export const setSessionToken = (value) => {
  token = value;
  try {
    if (value) sessionStorage.setItem('authToken', value);
    else sessionStorage.removeItem('authToken');
  } catch (error) {
    console.warn('Unable to update session cache:', error.message);
  }
};
export const clearSession = (message = '') => {
  setSessionToken(null);
  revision += 1;
  listeners.forEach((listener) => listener(message));
};
export const onSessionCleared = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
